module.exports = __webpack_public_path__ + "img/rvn.14fbba9f.svg";